import React, { useEffect, useState } from 'react';
import './Termsandconditions.css';
import { Helmet } from 'react-helmet';
import axios from 'axios';

const TermsAndConditions = () => {
  const [metaTags, setMetaTags] = useState([]);

  useEffect(() => {
    document.title = "Terms and Conditions - Funfillia";

    const fetchMetaTags = async () => {
      try {
        const res = await axios.get('https://api.funfillia.com/api/v2/website/metaTags/terms_and_conditions', {
          headers: {
            Accept: 'application/json',
            'Client-Domain':'www.funfillia.com',
          },
        });

        const htmlString = res.data?.metaTags || '';
        const doc = new DOMParser().parseFromString(htmlString, 'text/html');
        const tags = Array.from(doc.head.children);
        setMetaTags(tags);
      } catch (err) {
        console.error("Error fetching meta tags for Terms and Conditions:", err);
      }
    };

    fetchMetaTags();
  }, []);

  const getMetaContent = (attr, value) => {
    const tag = metaTags.find((t) => t.getAttribute(attr) === value);
    return tag?.getAttribute('content') || '';
  };

  return (
    <>
      <Helmet>
        <title>Terms and Conditions - Funfillia</title>

        {/* General Meta */}
        <meta name="title" content={getMetaContent('name', 'title')} />
        <meta name="description" content={getMetaContent('name', 'description')} />
        <meta name="keywords" content={getMetaContent('name', 'keywords')} />
        <link rel="canonical" href={window.location.href} />

        {/* Open Graph */}
        <meta property="og:type" content={getMetaContent('property', 'og:type')} />
        <meta property="og:url" content={getMetaContent('property', 'og:url')} />
        <meta property="og:title" content={getMetaContent('property', 'og:title')} />
        <meta property="og:description" content={getMetaContent('property', 'og:description')} />
        <meta property="og:image" content={getMetaContent('property', 'og:image')} />

        {/* Twitter */}
        <meta name="twitter:card" content={getMetaContent('name', 'twitter:card')} />
        <meta name="twitter:url" content={getMetaContent('name', 'twitter:url')} />
        <meta name="twitter:title" content={getMetaContent('name', 'twitter:title')} />
        <meta name="twitter:description" content={getMetaContent('name', 'twitter:description')} />
        <meta name="twitter:image" content={getMetaContent('name', 'twitter:image')} />
      </Helmet>

      <div className="terms-container">
        <div className="terms-box">
          <h1>Terms and Conditions</h1>
          <p><strong>Effective Date:</strong> April 9, 2025</p>

          <p>Welcome to <strong>Funfillia</strong>! By accessing and using our entertainment blogging site, you agree to the following terms and conditions. Please read them carefully.</p>

          <h2>1. Acceptance of Terms</h2>
          <p>By using Funfillia, you agree to be bound by these Terms and Conditions and our Privacy Policy. If you do not agree, please do not use our site.</p>

          <h2>2. Content Usage</h2>
          <p>All blogs and content published on Funfillia are for entertainment purposes only. You may not copy, reproduce, or distribute any content without our written permission.</p>

          <h2>3. User Conduct</h2>
          <p>You agree not to use the site to:</p>
          <ul>
            <li>Post harmful or offensive content</li>
            <li>Engage in unlawful or fraudulent activities</li>
            <li>Violate the intellectual property rights of others</li>
          </ul>

          <h2>4. Comments and Interactions</h2>
          <p>We encourage fun and respectful discussions. However, we reserve the right to remove any comments that are abusive, spammy, or violate our guidelines.</p>

          <h2>5. Modifications</h2>
          <p>We may update these Terms from time to time. It is your responsibility to review this page periodically for changes.</p>

          <h2>6. Third-Party Links</h2>
          <p>Funfillia may contain links to external websites. We are not responsible for the content or practices of those websites.</p>

          <h2>7. Disclaimer</h2>
          <p>The content on Funfillia is for entertainment only and is not intended to provide professional advice.</p>

          <h2>8. Contact Us</h2>
          <p>If you have any questions about these Terms, please email us at <strong><a href="mailto:info@funfillia.com">info@funfillia.com</a></strong>.</p>
        </div>
      </div>
    </>
  );
};

export default TermsAndConditions;
